import { apiLanguage } from './language';

const GRAPHQL_URL = process.env.REACT_APP_GRAPHQL_URL;

const GAME_PREVIEW_QUERY = `
  query GamePreview($id: ID!) {
    gamePreview(id: $id) {
      id
      status
      mode
      startDate
      endDate
      description
      currency
      price
      seats
      numberOfTeams
      currentPlayers
      currentTeams
      audience { id name }
      sportType { id name image }
      venue {
        id
        name
        address
        coordinate { latitude longitude }
      }
    }
  }
`;

export const fetchGamePreview = async (id, language) => {
  const res = await fetch(GRAPHQL_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      lang: apiLanguage(language, 'en'),
    },
    body: JSON.stringify({
      query: GAME_PREVIEW_QUERY,
      variables: { id },
    }),
  });

  if (!res.ok) {
    throw new Error(`HTTP ${res.status}`);
  }

  const body = await res.json();
  if (body.errors && body.errors.length) {
    const err = new Error(body.errors[0].message || 'GraphQL error');
    err.graphql = body.errors;
    throw err;
  }

  return body.data?.gamePreview || null;
};
